module.exports = __webpack_public_path__ + "static/img/mode-video_check@2x.44fa7782.png";